export default {
    'it-IT': {
        ordersListEmpty: 'Non hai ancora effettuato alcun ordine.',
        ordersListEmptyText: `Puoi cominciare guardando gli <a class="link" href="{latestArrivalsLink}">ultimi arrivi</a>, troverai nuovi prodotti e nuovi brand per chi vuole essere sempre aggiornato.
        Oppure preferisci dare un\'occhiata ai nostri <a class="link" href="{offersLink}">prodotti in offerta</a>?
        <b>La scelta è tua</b>, il piacere di offrirti il miglior servizio possibile è tutto nostro.
        <b>Buoni acquisti su LordGun!</b>`,
        oneMoreProduct: '+ {n} altro',
        moreProducts: '+ {n} altri',
        orderNumber: 'Ordine n°',
        orderDate: 'Effettuato il',
        orderStatus: "Stato dell'ordine",
        orderStatusDetails:
            'Maggiori informazioni sullo stato dell\'ordine nella sezione <a href={link} class="link">Disponibilità e Ordini</a>.',
        returnStatusDetails:
            'Maggiori informazioni sullo stato del reso nella sezione <a href={link} class="link">Resi</a>.',
        trackOrder: 'Controlla la spedizione',
        returnStatus: 'Stato del reso n° {num}',
        cancelOrderButton: 'Annulla ordine',
        cancelOrderNotAllowed: "Non è più possibile annullare l'ordine",
        returnOrderButton: 'Chiedi un reso',
        returnDetailsButton: 'Visualizza dettagli reso n° {num}',
        seeDetails: 'Visualizza dettagli ordine',
        seeLessDetails: 'Visualizza meno dettagli',
        payment: 'Pagamento',
        shipping: 'Spedizione',
        lines: {
            product: 'Prodotto',
            qty: 'Qta',
            price: 'Totale',
            productsTotal: 'Totale prodotti',
            coupon: 'Coupon',
            shippingFees: 'Spese di spedizione',
            otherFees: "Spese d'incasso",
            orderTotal: 'Totale ordine',
            returnQty: 'Qta da rendere',
        },
        shippingAddress: 'Indirizzo di spedizione',
        billingAddress: 'Indirizzo di fatturazione',
        tel: 'Telefono',
        documentsTitle: "Documenti relativi all'ordine",
        creditNote: 'Nota di credito {num}',
        invoice: 'Fattura {num}',
        cancelOrder: {
            title: "Voglio annullare l'ordine n° {orderNumber}",
            text: "Con la procedura di annullamento ordine, si annulla completamente l'ordine: non è possibile modificare l'ordine, annullarne solo una parte, richiedere la modifica dell'indirizzo di spedizione o di fatturazione, cambiare metodo di pagamento, cambiare metodo di spedizione, aggiungere codici sconto.",
            sendCancelOrderRequest: 'Invia richiesta',
            info: 'Al momento dell\'invio la richiesta di annullamento verrà presa in carico da un operatore, per maggiori informazioni leggere <a class="link" href="{link}" alt="Disponibilità e ordini">Disponibilità e ordini</a>',
        },
        returnOrder: {
            title: "Voglio chiedere il reso dell'ordine n° {orderNumber}",
            sendReturnOrderRequest: 'Invia richiesta',
            selectLines:
                'Seleziona i prodotti per i quali vuoi richiedere il reso',
            selectLinesInfo:
                'Spunta il quadratino di fianco al prodotto o ai prodotti per cui vuoi chiedere un reso, poi clicca su "Conferma selezione": troverai un form da compilare per inviare la domanda di reso.',
            confirmSelection: 'Conferma selezione',
            error: 'Errore: è necessario selezionare almeno un prodotto.',
        },
    },
    'en-AU': {
        ordersListEmpty: 'No order has been placed.',
        ordersListEmptyText: `You can start by looking at the <a class="link" href="{latestArrivalsLink}">latest arrivals</a>, where you will be able to find new products and brands for those who want to stay in the trend.
        Or you can take a look at the products we currently have on <a class="link" href="{offersLink}">offer</a>.
        <b>The choice is yours</b>, it is our pleasure to offer you the best possible service.
        <b>Enjoy your shopping on LordGun!</b>`,
        oneMoreProduct: '+ {n} altro',
        moreProducts: '+ {n} altri',
        orderNumber: 'Order n°',
        orderDate: 'Placed on',
        orderStatus: 'Order status',
        orderStatusDetails:
            'More information on the status of the order <a href={link} class="link">Availability and Orders</a>.',
        returnStatusDetails:
            'More information on the status of the return in the section <a href={link} class="link">Returns</a>.',
        trackOrder: 'Track your order',
        returnStatus: 'Return {num} status',
        cancelOrderButton: 'Cancel order',
        cancelOrderNotAllowed: 'It is no longer possible to cancel your order',
        returnOrderButton: 'Ask for a return',
        returnDetailsButton: 'View return n° {num} details',
        seeDetails: 'See order details',
        seeLessDetails: 'See less',
        payment: 'Payment',
        shipping: 'Shipping',
        lines: {
            product: 'Product',
            qty: 'Qty',
            price: 'Total',
            productsTotal: 'Products total',
            coupon: 'Coupon',
            shippingFees: 'Shipping fees',
            otherFees: 'Collection fees',
            orderTotal: 'Order total',
        },
        shippingAddress: 'Shipping address',
        billingAddress: 'Billing address',
        tel: 'Telephone',
        documentsTitle: 'Documents related to the order',
        creditNote: 'Credit note {num}',
        invoice: 'Invoice {num}',
        cancelOrder: {
            title: 'I would like to cancel order n° {orderNumber}',
            text: 'With the order cancellation process, the order will be completely cancelled: it is not possible to modify, cancel one part, request to modify the shipping or billing address, change the payment method, change the shipping method or adding of discount codes to your order.',
            sendCancelOrderRequest: 'Send request',
            info: 'On sending the cancellation, the request will be taken over by an operator, for more information please read <a class="link" href="{link}" alt="Availability and Orders">Availability and Orders</a>',
        },
        returnOrder: {
            title: 'I want to request the return of the order n° {orderNumber}',
            sendReturnOrderRequest: 'Send request',
            selectLines: 'Select the product(s) you would like to return',
            selectLinesInfo:
                'Check the box next to the product or products which you would like to return, then click on "confirm selection": you will find a form that you need to fill out to request return',
            confirmSelection: 'Confirm selection',
            error: 'Error: you need to select at least one product',
        },
    },
    'en-GB': {
        ordersListEmpty: 'No order has been placed.',
        ordersListEmptyText: `You can start by looking at the <a class="link" href="{latestArrivalsLink}">latest arrivals</a>, where you will be able to find new products and brands for those who want to stay in the trend.
        Or you can take a look at the products we currently have on <a class="link" href="{offersLink}">offer</a>.
        <b>The choice is yours</b>, it is our pleasure to offer you the best possible service.
        <b>Enjoy your shopping on LordGun!</b>`,
        orderNumber: 'Order n°',
        orderDate: 'Placed on',
        orderStatus: 'Order status',
        orderStatusDetails:
            'More information on the status of the order <a href={link} class="link">Availability and Orders</a>.',
        returnStatusDetails:
            'More information on the status of the return in the section <a href={link} class="link">Returns</a>.',
        trackOrder: 'Track your order',
        returnStatus: 'Return {num} status',
        cancelOrderButton: 'Cancel order',
        cancelOrderNotAllowed: 'It is no longer possible to cancel your order',
        returnOrderButton: 'Ask for a return',
        returnDetailsButton: 'View return n° {num} details',
        seeDetails: 'See order details',
        seeLessDetails: 'See less',
        payment: 'Payment',
        shipping: 'Shipping',
        lines: {
            product: 'Product',
            qty: 'Qty',
            price: 'Total',
            productsTotal: 'Products total',
            coupon: 'Coupon',
            shippingFees: 'Shipping fees',
            otherFees: 'Collection fees',
            orderTotal: 'Order total',
        },
        shippingAddress: 'Shipping address',
        billingAddress: 'Billing address',
        tel: 'Telephone',
        documentsTitle: 'Documents related to the order',
        creditNote: 'Credit note {num}',
        invoice: 'Invoice {num}',
        cancelOrder: {
            title: 'I would like to cancel order n° {orderNumber}',
            text: 'With the order cancellation process, the order will be completely cancelled: it is not possible to modify, cancel one part, request to modify the shipping or billing address, change the payment method, change the shipping method or adding of discount codes to your order.',
            sendCancelOrderRequest: 'Send request',
            info: 'On sending the cancellation, the request will be taken over by an operator, for more information please read <a class="link" href="{link}" alt="Availability and Orders">Availability and Orders</a>',
        },
        returnOrder: {
            title: 'I want to request the return of the order n° {orderNumber}',
            sendReturnOrderRequest: 'Send request',
            selectLines: 'Select the product(s) you would like to return',
            selectLinesInfo:
                'Check the box next to the product or products which you would like to return, then click on "confirm selection": you will find a form that you need to fill out to request return',
            confirmSelection: 'Confirm selection',
            error: 'Error: you need to select at least one product',
        },
    },
    'en-US': {
        ordersListEmpty: 'No order has been placed.',
        ordersListEmptyText: `You can start by looking at the <a class="link" href="{latestArrivalsLink}">latest arrivals</a>, where you will be able to find new products and brands for those who want to stay in the trend.
        Or you can take a look at the products we currently have on <a class="link" href="{offersLink}">offer</a>.
        <b>The choice is yours</b>, it is our pleasure to offer you the best possible service.
        <b>Enjoy your shopping on LordGun!</b>`,
        orderNumber: 'Order n°',
        orderDate: 'Placed on',
        orderStatus: 'Order status',
        orderStatusDetails:
            'More information on the status of the order <a href={link} class="link">Availability and Orders</a>.',
        returnStatusDetails:
            'More information on the status of the return in the section <a href={link} class="link">Returns</a>.',
        trackOrder: 'Track your order',
        returnStatus: 'Return {num} status',
        cancelOrderButton: 'Cancel order',
        returnDetailsButton: 'View return n° {num} details',
        cancelOrderNotAllowed: 'It is no longer possible to cancel your order',
        returnOrderButton: 'Ask for a return',
        seeDetails: 'See order details',
        seeLessDetails: 'See less',
        payment: 'Payment',
        shipping: 'Shipping',
        lines: {
            product: 'Product',
            qty: 'Qty',
            price: 'Total',
            productsTotal: 'Products total',
            coupon: 'Coupon',
            shippingFees: 'Shipping fees',
            otherFees: 'Collection fees',
            orderTotal: 'Order total',
        },
        shippingAddress: 'Shipping address',
        billingAddress: 'Billing address',
        tel: 'Telephone',
        documentsTitle: 'Documents related to the order',
        creditNote: 'Credit note {num}',
        invoice: 'Invoice {num}',
        cancelOrder: {
            title: 'I would like to cancel order n° {orderNumber}',
            text: 'With the order cancellation process, the order will be completely cancelled: it is not possible to modify, cancel one part, request to modify the shipping or billing address, change the payment method, change the shipping method or adding of discount codes to your order.',
            sendCancelOrderRequest: 'Send request',
            info: 'On sending the cancellation, the request will be taken over by an operator, for more information please read <a class="link" href="{link}" alt="Availability and Orders">Availability and Orders</a>',
        },
        returnOrder: {
            title: 'I want to request the return of the order n° {orderNumber}',
            sendReturnOrderRequest: 'Send request',
            selectLines: 'Select the product(s) you would like to return',
            selectLinesInfo:
                'Check the box next to the product or products which you would like to return, then click on "confirm selection": you will find a form that you need to fill out to request return',
            confirmSelection: 'Confirm selection',
            error: 'Error: you need to select at least one product',
        },
    },
    'fr-FR': {
        ordersListEmpty: "Aucune commande n'a été effectuée.",
        ordersListEmptyText: `Commencez par les <a class="link" href="{latestArrivalsLink}">nouveautés</a>! Vous trouverez tous les nouveaux produits et les nouvelles marques pour suivre les dernières tendances.
        Ou vous préférez peut-être jeter un coup d\'œil à nos <a class="link" href="{offersLink}">offres</a>?
        C\'est à vous de choisir</b> et à nous d\'offrir le meilleur service possible.
        <b>Bon shopping sur LordGun!</b>`,
        oneMoreProduct: '+ {n} altro',
        moreProducts: '+ {n} altri',
        orderNumber: 'Commande n°',
        orderDate: 'Effectuée le',
        orderStatus: 'État de la commande',
        orderStatusDetails:
            'Plus d\'informations sur l\'état de la commande <a href={link} class="link">Disponibilité et commandes</a>.',
        returnStatusDetails:
            'Informations supplémentaires sur le statut du retour dans la section <a href={link} class="link">Retour</a>.',
        trackOrder: 'Suivi du colis',
        returnStatus: 'Statut du retour {num}',
        cancelOrderButton: 'Annuler ma commande',
        cancelOrderNotAllowed:
            "L'annulation de la commande n'est plus possible.",
        returnOrderButton: 'Demander un retour',
        returnDetailsButton: 'Visualisez détails retour n° {num}',
        seeDetails: 'Voir détails commande',
        seeLessDetails: 'Voir moins de détails',
        payment: 'Paiement',
        shipping: 'Expédition',
        lines: {
            product: 'Produit',
            qty: 'Qté',
            price: 'Total',
            productsTotal: 'Total des produits',
            coupon: 'Bon',
            shippingFees: "Frais d'envoi",
            otherFees: "Frais d'encaissement",
            orderTotal: 'Total de la commande',
        },
        shippingAddress: 'Adresse de livraison',
        billingAddress: 'Adresse de facturation',
        tel: 'Téléphone',
        documentsTitle: 'Documents relatifs à la commande',
        creditNote: 'Note de crédit {num}',
        invoice: 'Facture {num}',
        cancelOrder: {
            title: 'Je souhaite annuler la commande n° {orderNumber}',
            text: "La procédure d'annulation de la commande entraîne son annulation complète: vous ne pouvez pas modifier votre commande, en annuler seulement une partie, demander un changement d'adresse (livraison ou facturation), modifier la méthode de paiement, changer le mode de livraison, ajouter un bon de réduction",
            sendCancelOrderRequest: 'Envoyer ma demande',
            info: 'Suite à son envoi, votre demande d\'annulation sera prise en charge par un opérateur, pour plus d\'informations veuillez consulter la rubrique <a class="link" href="{link}" alt="Disponibilité et commandes">Disponibilité et commandes</a>.',
        },
        returnOrder: {
            title: 'Je veux demander le retour de la commande n° {orderNumber}',
            sendReturnOrderRequest: 'Demande envoyée',
            selectLines:
                'Sélectionnez les produits pour lesquels vous souhaitez demander un retour',
            selectLinesInfo:
                'Cochez la case à côté du ou des produits pour lesquels vous souhaitez demander un retour, puis cliquez sur "Confirmer la sélection": vous trouverez un formulaire à remplir pour soumettre votre demande de retour.',
            confirmSelection: 'Confirmez la sélection',
            error: 'Erreur: au moins un produit doit être sélectionné.',
        },
    },
    'es-ES': {
        ordersListEmpty: 'No se ha realizado ningún pedido.',
        ordersListEmptyText: `Si eres de los que quiere estar siempre actualizado, puedes empezar por las <a class="link" href="{latestArrivalsLink}">novedades</a>. Encontrarás lo último en productos y marcas.
        ¿O tal vez prefieras ojear nuestros <a class="link" href="{offersLink}">productos en oferta</a>?
        <b>La elección es tuya</b>, el placer de ofrecerte el mejor servicio ¡es nuestro!
        <b>¡Diviértete comprando en LordGun!</b>`,
        oneMoreProduct: '+ {n} altro',
        moreProducts: '+ {n} altri',
        orderNumber: 'Pedido n°',
        orderDate: 'Efectuado el',
        orderStatus: 'Estado del pedido',
        orderStatusDetails:
            'Más información sobre el estado del pedido <a href={link} class="link">Disponibilidad y pedidos</a>.',
        returnStatusDetails:
            'Leer más sobre el estado de tu devolución en la sección <a href={link} class="link">Devolución</a>.',
        trackOrder: 'Seguir el estado del envío',
        returnStatus: 'Estado de la devolución {num}',
        cancelOrderButton: 'Cancelar pedido',
        cancelOrderNotAllowed: 'Ya no es posible cancelar el pedido.',
        returnOrderButton: 'Solicitar una devolución',
        returnDetailsButton: 'Visualizar detalles devolución n° {num}',
        seeDetails: 'Ver detalles del pedido',
        seeLessDetails: 'Ver menos detalles',
        payment: 'Pago',
        shipping: 'Envío',
        lines: {
            product: 'Producto',
            qty: 'Cant',
            price: 'Total',
            productsTotal: 'Total de los productos',
            coupon: 'Cupón',
            shippingFees: 'Gastos de envío',
            otherFees: 'Gastos de gestió',
            orderTotal: 'Total del pedido',
        },
        shippingAddress: 'Dirección de entrega',
        billingAddress: 'Dirección de facturación',
        tel: 'Teléfono',
        documentsTitle: 'Documentos relacionados con el pedido',
        creditNote: 'Nota de crédito {num}',
        invoice: 'Factura {num}',
        cancelOrder: {
            title: 'Quiero cancelar el pedido n° {orderNumber}',
            text: 'Con este procedimiento, el pedido será cancelado en su totalidad: no será posible modificar el pedido, dirección de envío o facturación. Tampoco se podrá cambiar la forma de pago, el tipo de envío seleccionado ni añadir un código descuento o cupón.',
            sendCancelOrderRequest: 'Enviar solicitud',
            info: 'Una vez enviada la solicitud de cancelación será atendida por un operador. Para mayor información leer <a class="link" href="{link}" alt="Disponibilidad y pedidos">Disponibilidad y pedidos</a>.',
        },
        returnOrder: {
            title: 'Quiero solicitar la devolución del pedido nº  {orderNumber}',
            sendReturnOrderRequest: 'Enviar solicitud',
            selectLines:
                'Selecciona los productos para los que deseas solicitar la devolución',
            selectLinesInfo:
                'Marca la casilla situada junto al producto o productos que quieras solicitar la devolución y, a continuación, "Confirma la selección": encontrarás un formulario que se debe completar para proceder con la solicitud de devolución.',
            confirmSelection: 'Confirma la selección',
            error: 'Error: debes seleccionar al menos un producto',
        },
    },
    'de-DE': {
        ordersListEmpty: 'Sie haben noch keine Bestellung aufgegeben.',
        ordersListEmptyText: `Sie können damit beginnen, sich die <a class="link" href="latestArrivalsLink}">Neuheiten</a> anzuschauen, wo Sie neue Produkte und Marken für diejenigen finden können, die im Trend bleiben wollen.
        Oder Sie werfen einen Blick auf die Produkte, die wir derzeit im <a class="link" href="{offersLink}">Angebot</a> haben.
        <b>Sie haben die Wahl</b>, es ist uns ein Vergnügen, Ihnen den bestmöglichen Service zu bieten.
        <b>Genießen Sie Ihren Einkauf bei LordGun!</b>`,
        oneMoreProduct: '+ {n} altro',
        moreProducts: '+ {n} altri',
        orderNumber: 'Bestellung Nr.',
        orderDate: 'Ausgeführt am',
        orderStatus: 'Bestellstatus',
        orderStatusDetails:
            'Mehr Informationen über den Bestellungsstatus finden Sie unter <a href={link} class="link">Verfügbarkeit und Bestellungen</a>.',
        returnStatusDetails:
            'Weitere Informationen über den Status der Retoure im Abschnitt <a href={link} class="link">Rücksendungen</a>.',
        trackOrder: 'Versand kontrollieren',
        returnStatus: 'Status der Retoure',
        noReturnAsked: 'Keine Retoure beantragt',
        returnNotAllowed: 'Rückgabe nicht mehr möglich',
        cancelOrderButton: 'Bestellung stornieren',
        cancelOrderNotAllowed:
            'Die Bestellung kann nicht mehr storniert werden',
        returnOrderButton: 'Rückgabe beantragen',
        returnDetailsButton: 'Details zur Retoure Nr. {num} anzeigen',
        seeDetails: 'Details zur Bestellung anzeigen',
        seeLessDetails: 'Weniger Details anzeigen',
        payment: 'Zahlungsart',
        shipping: 'Versand',
        lines: {
            product: 'Produkt',
            qty: 'Menge',
            price: 'Summe',
            productsTotal: 'Produktsumme',
            coupon: 'Gutschein',
            shippingFees: 'Versandkosten',
            otherFees: 'Einzugs- und Bankgebühren',
            orderTotal: 'Bestellsumme',
        },
        shippingAddress: 'Versandadresse',
        billingAddress: 'Rechnungsadresse',
        tel: 'Telefon',
        documentsTitle: 'Bestellungsunterlagen',
        creditNote: 'Gutschriftsanzeige {num}',
        invoice: 'Rechnung {num}',
        cancelOrder: {
            title: 'Ich möchte die Bestellung Nr. {orderNumber} löschen',
            text: 'Mit dem Bestellstornierungsverfahren wird die Bestellung komplett storniert. Folgendes ist nicht möglich: die Bestellung ändern, nur ein Teil der Bestellung stornieren, die Änderung der Lieferadresse oder der Rechnungsanschrift beantragen, die Zahlungsart ändern, die Versandmethode ändern, einen Rabattcode hinzufügen.',
            sendCancelOrderRequest: 'Anfrage schicken',
            info: 'Sobald die Stornierungsanfrage geschickt wird, wird sie von einem Mirarbeiter bearbeitet. Für mehrere Informationen, lesen Sie bitte <a class="link" href="{link}" alt="Disponibilità e ordini">Verfügbarkeit und Bestellungen</a>',
        },
        returnOrder: {
            title: 'Ich möchte die Rückgabe der Bestellung Nr. {orderNumber} beantragen.',
            sendReturnOrderRequest: 'Anfrage senden',
            selectLines: 'Wählen Sie das Produkt, das Sie retournieren möchten',
            selectLinesInfo:
                'Kreuzen Sie das Kästchen neben dem Produkt oder den Produkten an, die Sie zurückgeben möchten, und klicken Sie dann auf "Auswahl bestätigen": Sie werden ein Formular finden, das Sie ausfüllen müssen, um die Rückgabe zu beantragen',
            confirmSelection: 'Bestätigung der Auswahl',
            error: 'Fehler: Es muss mindestens ein Produkt ausgewählt werden.',
        },
    },
};
